import { CreateClientFormKey } from "../../pages/createClient/modelsAndSchemas/Models";

type CreateClientFormKeyType =
  (typeof CreateClientFormKey)[keyof typeof CreateClientFormKey];

export type ErrorCodesType = {
  [key: number]: {
    fieldKey: CreateClientFormKeyType | "";
    fieldName: string;
  };
};

export const BEErrorCodes: ErrorCodesType = {
  1000: { fieldKey: "", fieldName: "" }, // CLIENT_NAME_REQUIRED
  1001: { fieldKey: "", fieldName: "" }, // CLIENT_TYPE_REQUIRED
  1002: { fieldKey: "", fieldName: "" }, // CLIENT_INDUSTRY_REQUIRED
  1003: { fieldKey: "", fieldName: "" }, // CLIENT_ADDRESS_COUNTRY_REQUIRED
  1004: { fieldKey: "", fieldName: "" }, // CLIENT_INVALID_ADDRESS_OR_BILLING_COUNTRY
  1005: { fieldKey: "", fieldName: "" }, // CLIENT_MAILING_ADDRESS1_REQUIRED
  1006: { fieldKey: "", fieldName: "" }, // CLIENT_COUNTRY_REQUIRED
  1007: { fieldKey: "", fieldName: "" }, // CLIENT_CITY_REQUIRED
  1008: { fieldKey: "", fieldName: "" }, // CLIENT_POSTAL_CODE_REQUIRED
  1009: { fieldKey: "", fieldName: "" }, // CLIENT_NAME_LENGTH_EXCEEDED
  1010: { fieldKey: "", fieldName: "" }, // CLIENT_ADDRESS1_LENGTH_EXCEEDED
  1011: { fieldKey: "", fieldName: "" }, // CLIENT_ADDRESS2_LENGTH_EXCEEDED
  1012: { fieldKey: "", fieldName: "" }, // CLIENT_ADDRESS3_LENGTH_EXCEEDED
  1013: { fieldKey: "", fieldName: "" }, // CLIENT_ADDRESS4_LENGTH_EXCEEDED
  1014: { fieldKey: "", fieldName: "" }, // CLIENT_ADDRESS5_LENGTH_EXCEEDED
  1015: { fieldKey: "", fieldName: "" }, // CLIENT_CITY_LENGTH_EXCEEDED
  1016: { fieldKey: "", fieldName: "" }, // INVALID_ORIGINATOR_ID
  1017: { fieldKey: "", fieldName: "" }, // INVALID_LOCAL_CLIENT_RELATIONSHIP_OWNER_ID
  1018: { fieldKey: "", fieldName: "" }, // INVALID_DEDICATED_PROJECT_MANAGER_ID
  1019: { fieldKey: "", fieldName: "" }, // INVALID_CLIENTID
  1020: { fieldKey: "", fieldName: "" }, // ORIGINDATE_REQUIRED
  1021: { fieldKey: "bin", fieldName: "Business Identification Number" }, // INVALID_BUSINESS_IDENTIFICATION_NUMBER
  1022: { fieldKey: "bin", fieldName: "Business Identification Number" }, // DUPLICATE_BUSINESS_IDENTIFICATION_NUMBER
  1023: { fieldKey: "siretNumber", fieldName: "Siret Number" }, // DUPLICATE_BUSINESS_IDENTIFICATION_NUMBER_SECTION
  1033: { fieldKey: "bin", fieldName: "Business Identification Number" }, // BUSINESS_IDENTIFICATION_NUMBER_SHOULD_BE_UNIQUE_OR_BE_USED_IN_HEIRARCHY
  1024: { fieldKey: "", fieldName: "" }, // CLIENT_ENGLISH_COMPANY_NAME_REQUIRED
  1025: { fieldKey: "", fieldName: "" }, // INVALID_CLIENT_ADDRESS_COUNTRY_NAME
  1026: { fieldKey: "", fieldName: "" }, // INVALID_CLIENT_BILLING_COUNTRY_NAME
  1027: { fieldKey: "", fieldName: "" }, // PARENT_CLIENT_ID_REQUIRED
  1028: { fieldKey: "", fieldName: "" }, // CHILD_CLIENT_ID_REQUIRED
  1029: { fieldKey: "", fieldName: "" }, // INVALID_PARENT_CLIENT_ID
  1030: { fieldKey: "", fieldName: "" }, // INVALID_CHILD_CLIENT_ID
  1031: { fieldKey: "", fieldName: "" }, // PARENT_CANNOT_BE_A_DESCENDANT_OF_THE_CHILD_CLIENT
  1032: { fieldKey: "", fieldName: "" }, // PARENT_CLIENT_ID_CANNOT_BE_SAME_AS_CHILD_CLIENT_ID
  1044: { fieldKey: "siretNumber", fieldName: "Siret Number" }, //
  1045: { fieldKey: "cin", fieldName: "CIN" }, //
  3000: { fieldKey: "", fieldName: "" }, // COMPANY_NAME_INVALID
  3001: { fieldKey: "", fieldName: "" }, // COMPANY_NAME_LENGTH_EXCEEDED
  3002: { fieldKey: "", fieldName: "" }, // CLIENT_CODE_INVALID
  3003: { fieldKey: "", fieldName: "" }, // CLIENT_CODE_LENGTH_EXCEEDED
  3004: { fieldKey: "", fieldName: "" }, // COMPANY_FILTER_REQUIRED
  3005: { fieldKey: "", fieldName: "" }, // CLIENT_FILTER_REQUIRED
  3006: { fieldKey: "", fieldName: "" }, // CITY_FILTER_REQUIRED
  3007: { fieldKey: "", fieldName: "" }, // ADDRESS_COUNTRY_REQUIRED
  3008: { fieldKey: "", fieldName: "" }, // CITY_INVALID
  3009: { fieldKey: "", fieldName: "" }, // CITY_LENGTH_EXCEEDED
  3010: { fieldKey: "", fieldName: "" }, // COMPANY_FILTER_MUST_NOT_CONTAIN_NUMBERS
  3011: { fieldKey: "", fieldName: "" }, // CLIENT_FILTER_MUST_NOT_CONTAIN_NUMBERS
  3012: { fieldKey: "", fieldName: "" }, // CITY_FILTER_MUST_NOT_CONTAIN_NUMBERS
  3013: { fieldKey: "", fieldName: "" }, // COMPANY_ALLOWED_FILTERS
  3014: { fieldKey: "", fieldName: "" }, // CLIENT_ALLOWED_FILTERS
  3015: { fieldKey: "", fieldName: "" }, // CITY_ALLOWED_FILTERS
  3016: { fieldKey: "", fieldName: "" }, // ADDRESS_COUNTRY_MUST_NOT_CONTAIN_NUMBERS
  3017: { fieldKey: "", fieldName: "" }, // CITY_MUST_NOT_CONTAIN_NUMBERS
  3018: { fieldKey: "", fieldName: "" }, // STATUS_MUST_NOT_CONTAIN_NUMBERS
  4000: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_CLIENTPROFILEID_REQUIRED
  4001: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_FIRSTNAME_REQUIRED
  4002: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_FIRSTNAME_LENGTH_EXCEEDED
  4003: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_FIRSTNAME_INVALID
  4004: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_LASTNAME_REQUIRED
  4005: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_LASTNAME_LENGTH_EXCEEDED
  4006: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_LASTNAME_INVALID
  4007: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_JOBTITLE_MIN_LENGTH
  4008: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_JOBTITLE_MAX_LENGTH
  4009: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_JOBTITLE_INVALID
  4010: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_JOBTITLE__REQUIRED
  4011: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_TELENO_MAX_LENGTH
  4012: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_TELENO_INVALID
  4013: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_MOBNO_MAX_LENGTH
  4014: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_MOBNO_INVALID
  4015: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_EMAIL_REQUIRED
  4016: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_EMAIL_INVALID
  4017: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_WORKEMAIL_REQUIRED
  4018: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_WORKEMAIL_INVALID
  4019: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_FAX_LENGTH_EXCEEDED
  4020: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_FAX_INVALID
  4021: { fieldKey: "", fieldName: "" }, // EXISTS_CONTACTID
  4022: { fieldKey: "", fieldName: "" }, // INVALID_CONTACTID
  4023: { fieldKey: "", fieldName: "" }, // NEW_CONTACT_SURVEYLANGUAGEID_REQUIRED
  4024: { fieldKey: "", fieldName: "" }, // NO_ CONTACTIDWITHCLIENTID  4025: {filedName: ''}, // EXISTS_WORKEMAIL
  4026: { fieldKey: "", fieldName: "" }, // CLIENT_BILLING_COUNTRY_REQUIRED
  4027: { fieldKey: "", fieldName: "" }, // CLIENT_BILLING_COUNTRY_NAME_REQUIRED
};
